/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_RETAILER_RENTAL_RECEIVE,
    CURRENT_RETAILER_RENTAL_REQUEST,
    CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS,
    CURRENT_RETAILER_RENTAL_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_RETAILER_RENTAL_REQUEST]: () => true,
    [CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS]: () => false,
    [CURRENT_RETAILER_RENTAL_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_RETAILER_RENTAL_RECEIVE]: (state, action) => action.payload.retailerRental,
});

export const id = createReducer([], {
    [CURRENT_RETAILER_RENTAL_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.retailerRental,
            (memo, subscription) => {
                const { id } = subscription.subscription;
                //console.log(subscription);
                //console.log(subscription.subscription);
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription.subscription;
                return subscription.subscription.id;
            },
            state,
        );
    },
});

export const subscription = createReducer([], {
    [CURRENT_RETAILER_RENTAL_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.retailerRental,
            (memo, subscription) => {
                const { id } = subscription.subscription;

                return subscription.subscription;
            },
            state,
        );
    },
});

// const id2 = createReducer(null, {
//     [CURRENT_RETAILER_RENTAL_RECEIVE]: (state, action) => action.payload.retailerRental.subscription.id,
// });

export const error = createReducer(false, {
    [CURRENT_RETAILER_RENTAL_REQUEST]: () => false,
    [CURRENT_RETAILER_RENTAL_REQUEST_SUCCESS]: () => false,
    [CURRENT_RETAILER_RENTAL_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    id,
    subscription,
    requesting,
    error
});
